/** How a console address names a space and an added activity, so no id ever reaches the bar. */

import type { AddedActivityRow, SpaceRow } from "../../types";

/** A join code is handed out in whatever case a person typed it; the space holds one spelling. */
export function spaceByCode(rows: readonly SpaceRow[], joinCode: string): SpaceRow | undefined {
  const wanted = joinCode.toUpperCase();
  return rows.find((one) => one.space.join_code.toUpperCase() === wanted);
}

function slugged(name: string): string {
  const out = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return out === "" ? "activity" : out;
}

/** One slug per added activity, unique within its space and stable however the api orders it. */
export function addedActivitySlugs(rows: readonly AddedActivityRow[]): Map<string, string> {
  const ordered = [...rows].sort((a, b) =>
    a.added_activity_id < b.added_activity_id ? -1 : a.added_activity_id > b.added_activity_id ? 1 : 0,
  );
  const seen = new Map<string, number>();
  const out = new Map<string, string>();
  for (const row of ordered) {
    const base = slugged(row.name);
    const count = (seen.get(base) ?? 0) + 1;
    seen.set(base, count);
    out.set(row.added_activity_id, count === 1 ? base : `${base}-${String(count)}`);
  }
  return out;
}

export function addedActivityBySlug(
  rows: readonly AddedActivityRow[],
  slug: string,
): AddedActivityRow | undefined {
  const slugs = addedActivitySlugs(rows);
  return rows.find((one) => slugs.get(one.added_activity_id) === slug);
}
